import { render } from "./Control_Tables.vue?vue&type=template&id=e1292ed0"
import script from "./Control_Tables.vue?vue&type=script&lang=js"
export * from "./Control_Tables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__